/**
 * @generated SignedSource<<73d6520047e33b45a971a1c75130b7fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type APIOverviewCustomerQuery$variables = {
  customerID: number;
  end: any;
  groupByUser: boolean;
  start: any;
};
export type APIOverviewCustomerQuery$data = {
  readonly customer: {
    readonly apiStats: ReadonlyArray<{
      readonly login: string | null;
      readonly method: string;
      readonly path: string;
      readonly queryString: string;
      readonly totalCount: number;
    }>;
    readonly name: string;
  } | null;
};
export type APIOverviewCustomerQuery = {
  response: APIOverviewCustomerQuery$data;
  variables: APIOverviewCustomerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "end"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupByUser"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "start"
},
v4 = [
  {
    "kind": "Variable",
    "name": "customerID",
    "variableName": "customerID"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "end",
          "variableName": "end"
        },
        {
          "kind": "Variable",
          "name": "start",
          "variableName": "start"
        }
      ],
      "kind": "ObjectValue",
      "name": "dateRange"
    },
    {
      "kind": "Variable",
      "name": "groupByUser",
      "variableName": "groupByUser"
    }
  ],
  "concreteType": "_APIStatForCustomer",
  "kind": "LinkedField",
  "name": "apiStats",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "queryString",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "method",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "APIOverviewCustomerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "customer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "APIOverviewCustomerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "customer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "80060b21c9fe6111d5711b88037ce8cc",
    "id": null,
    "metadata": {},
    "name": "APIOverviewCustomerQuery",
    "operationKind": "query",
    "text": "query APIOverviewCustomerQuery(\n  $customerID: Int!\n  $start: Date!\n  $end: Date!\n  $groupByUser: Boolean!\n) {\n  customer(customerID: $customerID) {\n    name\n    apiStats(dateRange: {start: $start, end: $end}, groupByUser: $groupByUser) {\n      path\n      queryString\n      method\n      login\n      totalCount\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "34c097dd95a021ecffa0984f75273b16";

export default node;
